import './LoadingSpinner.css';

export const LoadingSpinner = ({Message}) => {
    return (<div className="loader-container">
    <div className="loader"></div>
    <p>{Message}</p>
</div>);
}